module.exports = __webpack_public_path__ + "media/images/members/explosion-white-2aedf8f720be06cb13795eb0ffe541b5.png";